import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import logo from '../logo.jpg';
import Icon from './Icon';
import { navLinks } from '../data/site';

const NewMenu = () => {
  const [open, setOpen] = useState(false);
  const close = () => setOpen(false);

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <Link to="/" className="brand" onClick={close}>
          <span className="brand__mark"><img src={logo} alt="" /></span>
          <span className="brand__name">Sneh Communications</span>
        </Link>

        <button
          type="button"
          className="menu-toggle"
          aria-label={open ? 'Close menu' : 'Open menu'}
          aria-expanded={open}
          aria-controls="site-nav"
          onClick={() => setOpen(!open)}
        >
          <Icon name={open ? 'close' : 'menu'} />
        </button>

        <nav id="site-nav" className={`site-nav ${open ? 'is-open' : ''}`} aria-label="Main">
          {navLinks.map((item) => (
            <NavLink key={item.to} to={item.to} end className="site-nav__link" onClick={close}>
              {item.label}
            </NavLink>
          ))}
          <Link to="/contact" className="button button--primary button--small" onClick={close}>Contact us</Link>
        </nav>
      </div>
    </header>
  );
};

export default NewMenu;
